<div class="modal-content" [class.shadow-none]="false">
  <div class="modal-header align-items-start">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ 'companyProfile.edit.title' | translate }}</h2>
      <p class="text-muted small mb-0">{{ 'userProfile.edit.requiredFieldsPrefix' | translate }} <span class="text-danger">*</span> {{ 'userProfile.edit.requiredFieldsSuffix' | translate }}</p>
    </div>
  </div>
  <div class="modal-body">
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="('companyProfile.edit.companyName' | translate) + ' *'"
          [placeholder]="'companyProfile.edit.companyName' | translate"
          [type]="'text'"
          [(value)]="company.company_name"
          [invalid]="isCompanyNameInvalid"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'companyProfile.edit.organisationNumber' | translate"
          [placeholder]="'companyProfile.edit.organisationNumber' | translate"
          [type]="'text'"
          [(value)]="company.organisation_number"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'companyProfile.edit.email' | translate"
          [placeholder]="'companyProfile.edit.email' | translate"
          [type]="'email'"
          [(value)]="company.email"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'companyProfile.edit.phone' | translate"
          [placeholder]="'companyProfile.edit.phone' | translate"
          [type]="'tel'"
          [(value)]="company.phone"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-selectorini
          [options]="countries"
          [displayKey]="'name'"
          [valueKey]="'country_id'"
          [(value)]="company.country_id"
          [label]="'companyProfile.edit.country' | translate"
          [placeholder]="'companyProfile.edit.countryPlaceholder' | translate"
          [searchable]="true"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'companyProfile.edit.address' | translate"
          [placeholder]="'companyProfile.edit.address' | translate"
          [type]="'text'"
          [(value)]="company.address"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'companyProfile.edit.city' | translate"
          [placeholder]="'companyProfile.edit.city' | translate"
          [type]="'text'"
          [(value)]="company.city"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'companyProfile.edit.postalCode' | translate"
          [placeholder]="'companyProfile.edit.postalCode' | translate"
          [type]="'number'"
          [(value)]="company.postal_code"
        />
      </div>
    </div>
<!--    <div class="row g-4 spacing-15">-->
<!--      <div class="col-lg-6 col-12">-->
<!--        <app-input-component-->
<!--          [label]="'Email'"-->
<!--          [placeholder]="'Email'"-->
<!--          [type]="'email'"-->
<!--          [(value)]="user.email"-->
<!--        />-->
<!--      </div>-->
<!--      <div class="col-lg-6 col-12">-->
<!--        <app-input-component-->
<!--          [label]="'Phone'"-->
<!--          [placeholder]="'Phone'"-->
<!--          [type]="'tel'"-->
<!--          [(value)]="user.phone"-->
<!--        />-->
<!--      </div>-->
<!--    </div>-->
    <div class="row g-4 spacing-15">
      <div class="col-lg-12 col-12">
        <app-markdown-editorini
          [value]="company.description"
          (valueChange)="company.description = $event"
        />
      </div>
    </div>

    <!-- Social Media & Web Links -->
    <div class="separator my-6"></div>
    <h4 class="fw-bold mb-4">
      <i class="fa-solid fa-share-nodes text-primary me-2"></i>{{ 'companyProfile.edit.socialMedia' | translate }}
    </h4>

    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'companyProfile.edit.website' | translate"
          [placeholder]="'https://yourwebsite.com'"
          [type]="'text'"
          [(value)]="company.website_url"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'companyProfile.edit.facebook' | translate"
          [placeholder]="'https://facebook.com/yourpage'"
          [type]="'text'"
          [(value)]="company.facebook_url"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'companyProfile.edit.instagram' | translate"
          [placeholder]="'https://instagram.com/yourprofile'"
          [type]="'text'"
          [(value)]="company.instagram_url"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'companyProfile.edit.youtube' | translate"
          [placeholder]="'https://youtube.com/@yourchannel'"
          [type]="'text'"
          [(value)]="company.youtube_url"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'companyProfile.edit.tiktok' | translate"
          [placeholder]="'https://tiktok.com/@yourprofile'"
          [type]="'text'"
          [(value)]="company.tiktok_url"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'companyProfile.edit.twitter' | translate"
          [placeholder]="'https://x.com/yourhandle'"
          [type]="'text'"
          [(value)]="company.twitter_url"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'companyProfile.edit.linkedin' | translate"
          [placeholder]="'https://linkedin.com/company/yourcompany'"
          [type]="'text'"
          [(value)]="company.linkedin_url"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'companyProfile.edit.merchandise' | translate"
          [placeholder]="'https://yourshop.com'"
          [type]="'text'"
          [(value)]="company.merchandise_url"
        />
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-between">
    <app-button
      [label]="deleting ? ('companyProfile.delete.deleting' | translate) : ('companyProfile.delete.button' | translate)"
      [variant]="'danger'"
      [iconClass]="deleting ? 'fa fa-spinner fa-spin' : 'fa fa-trash'"
      [disabled]="saving || deleting"
      (clicked)="openDeleteConfirmation()"
    />
    <app-button
      [label]="saving ? ('companyProfile.edit.saving' | translate) : ('companyProfile.edit.save' | translate)"
      [variant]="'primary'"
      [iconClass]="saving ? 'fa fa-spinner fa-spin' : 'fa fa-save'"
      [disabled]="saving || deleting"
      (clicked)="save()"
    />
  </div>
</div>
